import { OnInit, OnDestroy, Component, Optional, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
declare let dojoApp: any;

@Component({
    selector: 'dojo-old-account-status',
    templateUrl: './dojo-old-account-status.component.html'
})
export class DojoOldAccountStatusComponent implements OnInit, OnDestroy {
    widgetName: string = 'nxi/widgets/accountstatus/DraftAccountStatus';
    widgetDomId: string = 'draftAccountStatus';
    widgetBodyClass: string = 'account-status-nao';
    subs: Subscription;
    baseUrl: string;
    params: any;
    queryParams: Params;
    IBD: string;
    isJointAccnt: boolean = false;
    constructor(
        private route: ActivatedRoute,
        private nxiRestService: NxiRestService,
        @Optional() @Inject('AppSettings') appSettings: any,
        private nxiWidgetParamsService: NxiWidgetParamsService) {
        this.baseUrl = this.nxiRestService.serviceUrl;
        if (appSettings.ibdConfigMap.IBD) {
            this.IBD = appSettings.ibdConfigMap.IBD;
        }
    }
    ngOnInit() {
        this.queryParams = this.route.snapshot.queryParams;
        this.nxiWidgetParamsService.renderAccountStatus(this.queryParams).subscribe(
            resp => {
                if (resp) {
                    if (resp.jointAcctCode) {
                        this.isJointAccnt = resp.jointAcctCode;
                    }
                    this.renderDojoWidget(resp);
                }
            }
        );
    }

    ngOnDestroy(): void {
        if (dojoApp) {
            dojoApp.destroyoldAccountWidget(this.widgetDomId);
        }
    }
    renderDojoWidget(params: any) {
        if (dojoApp) {
            params.storeUrl = this.baseUrl + '/portfolio/account-status?signind=' + this.queryParams.signind + '&txt=' + params.txt + '&token=' + params.token;
            params.ibd = this.IBD;
            dojoApp.renderoldAccountWidget(params, this.widgetName, this.widgetDomId);
        }
    }

}
